import { withEventBasedMarketTemplateModelState } from '@swf/sports/models/market-templates/eventBased';

import type { SportsEventPageState } from './types';

export const defaultState = withEventBasedMarketTemplateModelState<SportsEventPageState>({
  isLoading: false,
  hasPreloaded: false,
  marketsFeature: []
});
